"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscribeState = void 0;
var SubscribeState;
(function (SubscribeState) {
    SubscribeState[SubscribeState["SUCCESS"] = 0] = "SUCCESS";
    SubscribeState[SubscribeState["UNCONFIRM"] = 1] = "UNCONFIRM";
    SubscribeState[SubscribeState["DUPLICATED"] = 2] = "DUPLICATED";
    SubscribeState[SubscribeState["UNKNOWN"] = 3] = "UNKNOWN";
})(SubscribeState = exports.SubscribeState || (exports.SubscribeState = {}));
